import { AuditActionReason } from './reason-code-audit-type';
import { AuditRejectReason } from './reason-code-reject-type';
import { FormRiskActionReason } from './reason-code-risk-action-type';
import { FormStatusReason } from './reason-code-status-type';
import { ReasonCodeEntityClass, ReasonCodePrimaryType } from './reason-code-type.enums';
import { IReasonCodeType } from './reason-code-type.interfaces';

const FormQualityReason: IReasonCodeType = {
  entityClass: ReasonCodeEntityClass.ProgramPeriodConfig,
  primaryType: ReasonCodePrimaryType.FormQualityReason,
};

export const ReasonCodeTypes = {
  FormQualityReason: [FormQualityReason],
  FormRiskActionReason,
  FormStatusReason,
  AuditActionReason,
  AuditRejectReason,
};
